import { datasetFactory } from '@fusioncharts/core/src/lib';
import MultiLevelPieDataset from '../dataset/multilevelpie';
/**
 * function to  create dataset, groupmaneger.
 * assign dataset to group manager.
 **/
export default function (chart) {
  let categories,
    catLength,
    length,
    datasetJSON = {}; // eslint-disable-line good-practices/no-single-usage-variable

  categories = (chart.config.categories = chart.getFromEnv('dataSource').category || []);
  catLength = categories.length;

  if (!length && catLength) {
    datasetJSON = categories;
    length = catLength;
  }
  // if the data has no categories in them.
  if (!catLength) {
    chart.setChartMessage();
    return;
  }
  datasetFactory(chart, MultiLevelPieDataset, 'dataset', length, [datasetJSON]);
}
